import * as React from "react";
import { css } from "@emotion/css";
import {
  BYOFundEntryInterface,
  OCPFundEntryInterface,
  BYOFundCustomPercentEntryInterface
} from "../support/interfaces/fundSelectionInterfaces";
import { PfFundSelectionOCP } from "./PfFundSelectionOCP";
import { PfFundSelectionBYO } from "./PfFundSelectionBYO";

/**
 * @prop `fundSelectionType` This is the drop value for fundselection, which is "ocp" or "byo".
 * @prop `funds` funds which are retrieved from backend and rendered.
 * @prop `onFundTypeChange`
 */

export interface PfFundSelectionProps {
  fundSelectionType: "byo" | "ocp";
  funds: {
    byo: BYOFundEntryInterface[];
    ocp: OCPFundEntryInterface[];
  };
  onFundTypeChange: React.ChangeEventHandler<HTMLSelectElement>;
  onOCPFundSelectionChanged: (arg0: OCPFundEntryInterface) => void;
  externalBindedOCPTargetValue: string;
  birthYear: number;
  BYOfundsMaxNumber: number;
  BYOfundChoices: BYOFundCustomPercentEntryInterface[];
  BYOOnAddFund: () => void;
  onFundSelectionChange: (
    fund: BYOFundEntryInterface | undefined,
    index: number
  ) => void;
  onPercentChange: (
    args0: React.FormEvent<HTMLInputElement>,
    args1: number
  ) => void;
  onRemoveEntry: (index: number) => void;
  validHandler: (isValid: boolean) => void;
}

export const PfFundSelection = ({
  fundSelectionType,
  funds,
  onFundTypeChange,
  onOCPFundSelectionChanged,
  externalBindedOCPTargetValue,
  birthYear,
  BYOfundsMaxNumber,
  BYOfundChoices,
  BYOOnAddFund,
  onFundSelectionChange,
  onPercentChange,
  onRemoveEntry,
  validHandler
}: PfFundSelectionProps) => {
  const fundTypeDropDownClass = css`
    width: 250px;
    font-family: "Roboto";
    font-weight: 700;
    text-transform: uppercase;
    font-size: 0.85em;
    background: #f6f7f7;
    margin-bottom: 20px;
    border-left: none;
    border-right: none;
    border-bottom: none;
    border-top: 2px solid #0069a6;
    padding: 0.5em 1em;
  `;

  return (
    <div>
      <select
        name="fundSelectionType"
        id="fundSelectionType"
        className={fundTypeDropDownClass}
        value={fundSelectionType}
        onChange={onFundTypeChange}
      >
        <option value="ocp">A Diversified Portfolio</option>
        <option value="byo">Build My Own Portfolio</option>
      </select>
      {fundSelectionType === "ocp" && (
        <PfFundSelectionOCP
          funds={funds.ocp}
          onOCPFundSelectionChanged={onOCPFundSelectionChanged}
          externalBindedValue={externalBindedOCPTargetValue}
          birthYear={birthYear}
        />
      )}
      {fundSelectionType === "byo" && (
        <PfFundSelectionBYO
          funds={funds.byo}
          maxFundNumber={BYOfundsMaxNumber}
          fundChoices={BYOfundChoices}
          onAddFund={BYOOnAddFund}
          onFundSelectionChange={onFundSelectionChange}
          onPercentChange={onPercentChange}
          onRemoveEntry={onRemoveEntry}
          setParentValid={validHandler}
        />
      )}
    </div>
  );
};
